module.exports = __webpack_public_path__ + "img/4.6ed87259.png";